<script setup lang="ts">
/**
 * The save state a document application shows next to the document title.
 * The host decides what the state is and how it reads; this only gives every
 * application the same icon, colour and wrapping for it.
 */
import { computed } from 'vue';
import AlertCircle from 'lucide-vue-next/dist/esm/icons/circle-alert.js'; import CheckCircle2 from 'lucide-vue-next/dist/esm/icons/circle-check.js'; import Circle from 'lucide-vue-next/dist/esm/icons/circle.js'; import LoaderCircle from 'lucide-vue-next/dist/esm/icons/loader-circle.js';
import '../office-view.css';

export type NxOfficeSaveTone = 'saved' | 'saving' | 'changed' | 'unsaved' | 'error';

const props = defineProps<{
  tone: NxOfficeSaveTone;
  label: string;
}>();

const icon = computed(() =>
  props.tone === 'saved'
    ? CheckCircle2
    : props.tone === 'saving'
      ? LoaderCircle
      : props.tone === 'error'
        ? AlertCircle
        : Circle
);
</script>

<template>
  <span class="nx-office-save-status" :data-tone="tone">
    <component :is="icon" class="nxt-icon-sm" aria-hidden="true" />
    <span class="nx-office-save-status__label" role="status">{{ label }}</span>
  </span>
</template>
